interface Items {
  /**
   * the items to be list stringified
   */
  items: any[]
}

export interface NoAndNoComma {
  /**
   * whether to remove the `and` or `or` between the second to last, and last item
   *
   * @example
   * const items = 'one, two, three'
   */
  noAndOr?: boolean
  /**
   * whether to remove the last comma
   *
   * @example
   * const items = 'one, two and three'
   */
  noComma?: boolean
  /**
   * use `or` instead of `and` to separate the second to last, and last item
   * @example
   * const items = 'one, two, or three'
   */
  or?: boolean
  /**
   * wrap the items in the supplied string
   *
   * @example
   * const list = listStringify({
   *  items: [1, 2, 3],
   *  noAndOr: true,
   *  wrap: '"',
   * })
   * // list === '"1","2","3"'
   */
  wrap?: string
}

export interface ListStringifyOptions extends Items, NoAndNoComma {}

/**
 * Formats the given items into a comma separated list
 *
 * there are options to modify the format of the list
 *
 * @example
 * const items = listStringify({items: ['one', 'two', 'three']}) // one, two, and three
 */
export const listStringify = ({
  items,
  noAndOr,
  noComma,
  or,
  wrap,
}: ListStringifyOptions): string => {
  const wrapped = wrap ? items.map((item) => `${wrap}${item}${wrap}`) : items
  const end = items.length - 1
  if (noAndOr || end < 1) return wrapped.join(', ')
  const firsts = wrapped.slice(0, end)
  const last = wrapped[end]
  const joined = firsts.join(', ')
  const separator = or ? 'or' : 'and'
  if (noComma) return `${joined} ${separator} ${last}`
  if (end === 1) return `${joined} ${separator} ${last}`
  return `${joined}, ${separator} ${last}`
}
